import { render, staticRenderFns } from "./FeaturedProductRow.vue?vue&type=template&id=f289c456&scoped=true&"
import script from "./FeaturedProductRow.vue?vue&type=script&lang=js&"
export * from "./FeaturedProductRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f289c456",
  null
  
)

export default component.exports